import { CardData } from '@/pages/Oversight/components/Card';
import { TableHeadData } from '@/pages/Oversight/components/Table';

const infoClient: CardData[] = [
  { label: 'Nome', value: 'João da Silva' },
  { label: 'Status', value: 'Ativo', user_status: 'active' },
  { label: 'ID', value: '1223' },
  { label: 'CPF', value: '123.456.789-00' },
  { label: 'E-mail', value: 'contato@silvermountain-solutions.com' },
  { label: 'Telefone', value: '+55 11 98765-4321' },
];

const infoCompany = [
  { label: 'Empresa', value: 'Velta Financial' },
  { label: 'CNPJ', value: '26.482.666/0001-17' },
  { label: 'Laudos e amostras disponíveis', value: '5 laudos • 4 amostras' },
  { label: 'Plano contratado', value: 'Proto Plus' },
  { label: 'Assinatura', value: 'Anual (parcelada)' },
  { label: 'Próximo pagamento', value: '03/05/2026' },
];

const infoADMUser: CardData[] = [
  { label: 'Nome', value: 'Maria Oliveira' },
  { label: 'Status do usuário', value: 'Ativo', user_status: 'active' },
  { label: 'ID', value: '1223' },
  { label: 'Tipo de usuário', value: '1223' },
  { label: 'Última atividade', value: 'Hoje • 14:32' },
  { label: 'E-mail', value: 'maria.oliveira@email.com' },
  { label: 'CPF', value: '123.456.789-00' },
];

type delegatedAccessAdm = {
  id: number;
  name: string;
  status: string;
  reason: string;
  finish_section: string;
  action: boolean;
};

const delegatedAccessAdmUser: delegatedAccessAdm[] = [];

export type DelegatedAccessTableRow = {
  id: number;
  name: string;
  status: string;
  reason: string;
  finish_section: string | null;
  action: boolean;
};

const delegatedAccessRow = [
  { id: 1, label: 'Cliente', key: 'name' },
  { id: 2, label: 'Status', key: 'status' },
  { id: 3, label: 'Motivo', key: 'reason' },
  { id: 4, label: 'Ação', key: 'action', sortable: false },
] satisfies TableHeadData<DelegatedAccessTableRow>[];

type sectionAdmUser = {
  id: number;
  starts_section: string;
  finish_section: string | null;
  status: string;
  delegated_access: number;
  action: boolean;
};

const sectionAdmUser: sectionAdmUser[] = [];

type SectionAdmUserRow = {
  id: number;
  starts_section: string;
  status: string;
  delegated_access: string;
  action: boolean;
};

const sectionAdmUserRow = [
  { id: 1, label: 'Início da sessão', key: 'starts_section' },
  { id: 2, label: 'Status', key: 'status' },
  { id: 3, label: 'Acessos delegados', key: 'delegated_access' },
  { id: 4, label: 'Ação', key: 'action', sortable: false },
] satisfies TableHeadData<SectionAdmUserRow>[];

export {
  infoClient,
  infoCompany,
  infoADMUser,
  sectionAdmUser,
  delegatedAccessAdmUser,
  delegatedAccessRow,
  sectionAdmUserRow,
};
